import { Component, ViewChild, OnInit, Input, Output, EventEmitter, OnChanges, AfterViewInit, ChangeDetectorRef, SimpleChanges, TemplateRef, ElementRef, Inject } from '@angular/core';
import { LoaderService } from '../../shared/loader/loader.service';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { Observable, Subscription } from 'rxjs';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';

@Component({
  selector: 'app-editfolderforForm',
  templateUrl: './editfolderforForm.component.html',
  styleUrls: ['./editfolderforForm.component.scss'] 
})

export class EditfolderforFormComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  formDialog: FormGroup;   
  formfoldername:string="";
  disabledUpdate:boolean=true;
  spinner:boolean=false;
  myOfficeID: any;
  OfficeIDList: any=[];

  constructor(private dialog: MatDialog, public dialogRef: MatDialogRef<EditfolderforFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private statusConst: StatusConstant,
    private formService: FormsService,private toastr: ToastrService,private statusConstant: StatusConstant) {   
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
    this.currentUser = jwt_decode(token); 
     var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)	
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
  }  
  
  ngOnInit(): void {
    this.data;
    var formFolderName =Object.values(this.data)[0];
    var type = Object.values(this.data)[3];
    if(type ==1){
    this.formfoldername="Folder";
    }
    if(type ==2){
      this.formfoldername="Template";
     }
    let groupaddtouchtype = {};
    this.formDialog = new FormGroup(groupaddtouchtype);
    this.formDialog.addControl('formFolderName', this.formBuilder.control(''));
    this.formDialog.controls.formFolderName.setValue(formFolderName);
  }     
    

  UpdateFolderName(data) {
    this.data;  
    var formFolderID = Object.values(this.data)[1];
    var type = Object.values(this.data)[3];

    if(type == 1){
      this.renameFolder(formFolderID,data)
    }
    if(type == 2){
      this.renameForm(formFolderID,data)
    }
  }
 

 renameFolder(formFolderID,data){
   this.disabledUpdate=true;
   this.spinner=true;
   let ReqModel = {
    id: formFolderID,
    name: data.formFolderName.trim(),    
    organizationID: Number(this.organizationId),
    databaseID:Number(this.databaseId),
    userId: this.currentUser.UID,
    officeID:this.myOfficeID
 }   
 this.formService.RenameFormFolder(ReqModel).subscribe(response => {
   if (response != undefined) {
     this.responseHolder = response;
     if (this.responseHolder.data == true && this.responseHolder.status == this.statusConst.statusSuccess) {      
       this.formDialog.reset();
       this.dialogRef.close("Updated");
       this.toastr.success('Folder Update successfully.', '', {
         timeOut: 3000,
       });     
     }
     if (this.responseHolder.data == false) {
      this.disabledUpdate=false;
      this.spinner=false;
      this.toastr.warning('Folder name already exist.', '', {
        timeOut: 3000,
      });
     }   
   }
 });
 }

 renameForm(formFolderID,data){
  this.disabledUpdate=true;
  this.spinner=true;
  var ReqModel1 ={
    formID:Number(formFolderID),
    formName:data.formFolderName.trim(),
    userID:this.currentUser.UID,
    organizationID:Number(this.organizationId),
    databaseID:Number(this.databaseId),
    officeID:this.myOfficeID
  }
  this.formService.CheckProjectTemplateName(ReqModel1).subscribe((response) => {
     if (response != undefined) {
      this.responseHolder = response;
      if (this.responseHolder.data == false) {            
        this.disabledUpdate=false;
        this.spinner=false;
        this.toastr.warning(this.responseHolder.message, '', {
          timeOut: 3000,
        });         
        } else {
          let ReqModel = {
            id: formFolderID,
            name: data.formFolderName.trim(),    
            organizationID: Number(this.organizationId),
            databaseID:Number(this.databaseId),
            userId: this.currentUser.UID,
            officeID:this.myOfficeID
         }   
         this.formService.RenameForm(ReqModel).subscribe(response => {
           if (response != undefined) {
             this.responseHolder = response;
             if (this.responseHolder.data == true && this.responseHolder.status == this.statusConst.statusSuccess) {              
               this.formDialog.reset();
               this.dialogRef.close("Updated");
               this.toastr.success('Template name update successfully.', '', {
                 timeOut: 3000,
               });     
             }           
           }
         });
        
        }
      } else {         
      }
    });

 
 }

 close() {
  this.formDialog.reset();
  this.dialog.closeAll();
 }

 onChange(text:any){
  if(text.formFolderName ==""){
    this.disabledUpdate=true;
    return this.disabledUpdate;
  }else{
    this.disabledUpdate=false;
    return this.disabledUpdate;
  }  
 }
  
}
